import React from 'react';
import './topbar.css';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../providers/AuthProvider';
import { IconButton } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

export default function Topbar({ showSidebar, setShowSidebar }) {
    const auth = useAuth();
    const user = auth.getUserData();

    const handleLogout = async () => {
        auth.logOut();
    };

    return (
        <div className="topbar">
            <div className="topbarWrapper">
                <div>
                        <IconButton
                            style={{ color: '#fff' }}
                            onClick={() => setShowSidebar(!showSidebar)}
                        >
                            <MenuOpenIcon fontSize="large" />
                        </IconButton>
                    <span className="topLeft">EPG SYSTEM</span>
                </div>
                <div className="topRight">
                    <span className="userInfo">
                        {' '}
                        {user?.name}({user?.role}){' '}
                    </span>
                    <div className="topbarIconContainer">
                        <Logout onClick={handleLogout} />
                    </div>
                </div>
            </div>
        </div>
    );
}
